import { Link } from 'react-router-dom';
import Stamp from '../components/Stamp';
import Flakes from '../components/Flakes';

export default function NotFoundPage() {
  return (
    <section className="relative bg-[#1F140E] grain text-[#FDFBF7] overflow-hidden">
      <Flakes />
      <div className="relative z-10 mx-auto max-w-6xl px-5 py-24 sm:py-32 flex flex-col items-start gap-8">
        <Stamp size={110} dark />
        <div>
          <p className="font-pricemono text-xs tracking-[0.25em] uppercase text-[#E5A83B]">404</p>
          <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight mt-3">
            Halaman Ini Sedang Tidak di Penggorengan
          </h1>
          <p className="mt-5 max-w-xl text-base sm:text-lg leading-relaxed text-[#E8DCC9]">
            Alamat yang Anda tuju tidak ditemukan. Mungkin tautannya sudah berubah — silakan kembali
            ke beranda atau langsung intip menu kami.
          </p>
        </div>
        <div className="flex flex-wrap gap-4">
          <Link
            to="/"
            data-testid="notfound-cta-home"
            className="inline-flex items-center bg-[#C84B27] text-[#FDFBF7] font-semibold px-7 py-3.5 rounded-md hover:bg-[#a93d1f] transition-colors active:scale-95"
          >
            Kembali ke Beranda
          </Link>
          <Link
            to="/menu/"
            data-testid="notfound-cta-menu"
            className="inline-flex items-center border-2 border-[#E5A83B] text-[#E5A83B] font-semibold px-7 py-3.5 rounded-md hover:bg-[#E5A83B] hover:text-[#1F140E] transition-colors active:scale-95"
          >
            Lihat Menu
          </Link>
        </div>
      </div>
    </section>
  );
}
